import React, { useEffect, useState } from 'react';
import '../styles/Countdown.css';

const Countdown = ({ onComplete }) => {
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (count > 0) {
      const timer = setTimeout(() => {
        setCount(count - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      onComplete(); // Llama a la función cuando el recuento termina
    }
  }, [count, onComplete]);

  return (
    <div className="countdown-container">
      <div className="countdown-number">{count}</div>
    </div>
  );
};

export default Countdown;
